import { Box, Button, Popover, Typography } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { format, isAfter } from "date-fns";
import { useState, MouseEvent } from "react";

interface Props {
  start: Date;
  end: Date;
  onChange: (start: Date, end: Date) => void;
}

export default function DateRangePopover({ start, end, onChange }: Props) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const open = Boolean(anchor);

  const handleStartChange = (d: Date | null) => {
    if (d && !isAfter(d, end)) onChange(d, end);
  };
  const handleEndChange = (d: Date | null) => {
    if (d && !isAfter(start, d)) onChange(start, d);
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        onClick={(e: MouseEvent<HTMLElement>) => setAnchor(e.currentTarget)}
        sx={{ textTransform: "none", borderColor: "#ccc", color: "#333" }}
      >
        {format(start, "dd.MM")} → {format(end, "dd.MM")}
        <Box component="span" sx={{ ml: 1, opacity: 0.5 }}>📅</Box>
      </Button>
      <Popover
        open={open}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box sx={{ display: "flex", p: 1 }}>
          <Box>
            <Typography variant="caption" sx={{ pl: 2 }}>Start</Typography>
            <DateCalendar value={start} onChange={handleStartChange} />
          </Box>
          <Box>
            <Typography variant="caption" sx={{ pl: 2 }}>End</Typography>
            <DateCalendar value={end} onChange={handleEndChange} />
          </Box>
        </Box>
      </Popover>
    </>
  );
}
